import script from "./ModalManageItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalManageItem.vue?vue&type=script&setup=true&lang=ts"

import "./ModalManageItem.vue?vue&type=style&index=0&id=433b3612&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433b3612"]])

export default __exports__